import { Component, OnInit } from '@angular/core';

import { BusinessService, BusinessStatus } from '../../services/business.service';

/**
 * SCRUM-260 / 265 — one line at the top of the personal area about the VIP
 * (business) subscription: ending soon, grace period, back to a normal
 * account with paused ads, or "set up your business profile".
 * Renders nothing for users who were never VIP.
 */
@Component({
  selector: 'app-business-status-banner',
  templateUrl: './business-status-banner.component.html',
  styleUrls: ['./business-status-banner.component.scss'],
  standalone: false,
})
export class BusinessStatusBannerComponent implements OnInit {
  status: BusinessStatus | null = null;
  dismissed = false;

  constructor(private business: BusinessService) {}

  ngOnInit(): void {
    this.business.status().subscribe((s) => (this.status = s));
  }

  get kind(): 'ending' | 'grace' | 'lapsed' | 'profile' | null {
    const s = this.status;
    if (!s || this.dismissed) return null;
    if (s.state === 'GRACE') return 'grace';
    if (s.state === 'LAPSED' && s.paused_ads_count > 0) return 'lapsed';
    if (s.state === 'ACTIVE' && s.ending_soon) return 'ending';
    if (s.state === 'ACTIVE' && s.should_prompt_profile) return 'profile';
    return null;
  }
}
